export default "__VITE_PUBLIC_ASSET__3f3df189__"